<template>
  <a
    class="card"
    :href="certification.url"
    v-if="!isHidden"
  >
    <div class="card__wrapper">
      <div
        class="card__header"
        :style="headerBgImageCss"
      >
        <div
          class="card__cover"
          :style="headerBgColorCss"
        />
        <div class="card__avatar"><img :src="iconUrl"></div>
      </div>
      <div class="card__content">
        <h4 class="h6 fw7 mb-15 black" v-html="name" />
        <p class="black">{{ shortDescription }}</p>
      </div>
      <div class="card__footer card__footer--icon">
        <svg class="icon icon-arrow-right">
          <use xlink:href="#icons-arrow-right" />
        </svg>
      </div>
    </div>
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Certification',
  props: ['certification', 'index'],
  computed: {
    ...mapGetters({
      showAllCertifications: 'getShowAllCertifications',
      visibleItemsCount: 'getFilterVisibleItemsCount',
    }),
    shortDescription() {
      return this.certification.short_description;
    },
    name() {
      return this.certification.name;
    },
    iconUrl() {
      return this.certification.icon ? this.certification.icon : null;
    },
    headerBgUrl() {
      return this.certification.background_image ? this.certification.background_image : null;
    },
    headerBgColorCss() {
      if (this.certification.backgroud_color && this.certification.background_image) {
        return `background-color: ${this.certification.backgroud_color}; opacity: 0.8;`;
      }
      else {
        return `background-color: ${this.certification.backgroud_color}`;
      }
    },
    headerBgImageCss() {
      if (this.headerBgUrl) {
        return `background-image: url(${this.headerBgUrl});`;
      }
    },
    isHidden() {
      return this.index >= this.visibleItemsCount && this.showAllCertifications == false
    }
  },
};
</script>
